<app-modal [open]="active" [size]="'lg'" (close)="closeDialog()" [name]="'mapmodal'">
  <div modal-header>
    <span *ngIf="address?.streetAddress">{{ address?.streetAddress }}<br /></span
    >{{ address?.cityStateZip }}
  </div>
  <div modal-body>
    <div class="mapmodal__requirements" *ngIf="data?.site?.specialSiteCondition">
      <div class="special-site-condition-header">Site Requirements</div>
      <div class="special-site-condition">
        {{ data?.site?.specialSiteCondition }}
      </div>
    </div>

    <div class="user-details">
      <p class="small-txt">Site Map</p>
    </div>
    <google-map
      *ngIf="mapsLoaded"
      height="400px"
      width="100%"
      [center]="center"
      [zoom]="zoom"
      [options]="mapOptions"
      ><map-polygon
        [paths]="polygonPaths"
        [options]="polygonOptions"
      ></map-polygon
    ></google-map>

    <div class="mapmodal__actions">
      <input
        type="text"
        class="input mapmodal__dir-input"
        [(ngModel)]="startAddress"
        placeholder="Enter your starting address for directions"
        data-testid="mapmodal-directions-input"
      />
      <button
        type="button"
        class="btn btn--primary"
        (click)="getDirections()"
        data-testid="mapmodal-directions"
      >
        Get Directions
      </button>
      <button
        type="button"
        class="btn btn--secondary mapmodal__open-maps"
        (click)="openInMaps()"
        data-testid="mapmodal-open-maps"
      >
        Open in Maps <span class="material-icons">open_in_new</span>
      </button>
    </div>
  </div>
</app-modal>
